import { createAction } from '@reduxjs/toolkit';
import {
  saveAccommodationSearchFormValues,
  saveAccommodationSearchResults,
  setAccommodationCurrentProvider,
  setAccommodationCurrentRoom,
  setAccommodationCurrentTotalPrice,
} from './accommodation_form';
import {
  clearForwardPreselect,
  clearReturnPreselect,
  saveJourneyFormValues,
  setJourneyDates,
  setJourneys,
  setOneSegmentStop,
  setSegmentStop,
  setServicePreselect,
} from './journey_form';
import { saveLuggageFormValues } from './luggage_form';
import { saveOptionalExtrasFormValues } from './optional_extras_form';
import { savePassengerFormValues } from './passenger_form';
import {
  saveDepartureServiceForm,
  saveOriginalServiceFormValues,
  saveReturnServiceForm,
  saveServiceFormValues,
} from './service_form';
import { saveVehicleFormValues } from './vehicle_form';

const setMetaFlow = createAction('ui/sealink/setMetaFlow');
const setFerryGrouping = createAction('ui/sealink/setFerryGrouping');
const setBookingTenant = createAction('ui/sealink/setBookingTenant');
const saveCheckoutFormValues = createAction(
  'ui/sealink/journey/saveCheckoutFormValues'
);
const setDraftBookingFormValues = createAction(
  'ui/sealink/setDraftBookingFormValues'
);

export {
  setMetaFlow,
  setFerryGrouping,
  saveJourneyFormValues,
  setJourneyDates,
  setJourneys,
  setSegmentStop,
  setOneSegmentStop,
  savePassengerFormValues,
  saveLuggageFormValues,
  saveVehicleFormValues,
  saveServiceFormValues,
  saveOriginalServiceFormValues,
  saveDepartureServiceForm,
  saveReturnServiceForm,
  saveAccommodationSearchFormValues,
  saveAccommodationSearchResults,
  setAccommodationCurrentProvider,
  setAccommodationCurrentRoom,
  setAccommodationCurrentTotalPrice,
  setBookingTenant,
  saveOptionalExtrasFormValues,
  saveCheckoutFormValues,
  clearForwardPreselect,
  clearReturnPreselect,
  setServicePreselect,
  setDraftBookingFormValues,
};
